import React from 'react'

const AboutUs = () => {
  return (
    <div className="m-auto text-center">About Us</div>
  )
}

export default AboutUs